import { applicationContext, uuid, QueryUtility, toUTCDate, getErrorMessage, resolveInitialEligibilityStatus } from 'core/utils';
import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { action, observable, computed, runInAction } from 'mobx';
import { FacilityOrderService, FacilityOrderStatusService, ItemSubcategoryService } from "application/facility-order/services"; //, FacilityOrderTemplateService, FacilityOrderTemplateNewFlowService, , FacilityOrderTemplateItemService,  } from "application/facility-order/services";
import { FacilityService } from "application/facility/services";
import { LookupService } from "common/services";
import { ItemCategoryService } from 'application/product/services';
import _ from 'lodash';
import { NikoPatientDetailService, NikoPatientTemplateService, NikoPatientTemplateItemService } from "application/niko-patient/services";
import { ModalParams } from 'core/models';
import { EligibilityStatusService } from 'application/eligibility-status/services';
// import { PickTicketHeaderService } from "application/pick-ticket/services";
// import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { FacilityInventoryCountDetailService } from "application/facility-inventory/services";
// import { ScheduleService } from 'application/schedule/services';
// import { PersonService } from 'application/person/services';
// import { LocalPatientService } from "application/patient/services";
import { InventoryRequestService } from '../../inventory-request/services';
import { HistoryService } from '../../history/services';

@applicationContext
class NikoFacilityOrderUSIntakePreviewViewStore extends BaseViewStore {
    @observable accessor facilityOrder;
    @observable accessor refreshKey = uuid();
    @observable accessor selectedStatusAbrv;
    @observable accessor selectedQuestions = [];
    @observable accessor itemCategories = [];
    @observable accessor fetchingData = false;
    @observable accessor disabled = false;
    @observable accessor nikoPatientDetails = [];
    @observable accessor insuranceChangeHistoryMap = {};
    @observable accessor showInsuranceChangeHistory = null;

    @computed
    get usIntakeStatus() { return this.facilityOrder ? this.facilityOrder.facilityOrderStatuses.find(x => x.status.abrv == "us-intake") : undefined; }
    @computed
    get clinicalReviewStatus() { return this.facilityOrder ? this.facilityOrder.facilityOrderStatuses.find(x => x.status.abrv == "clinical-review") : undefined; }
    @computed
    get disabledByStatus() { return !(this.usIntakeStatus && this.usIntakeStatus.startedOn); }
    @computed
    get disabledBySendOrder() { return !this.isAdmin && this.facilityOrder && this.facilityOrder.sendOrder; }

    @observable accessor isReviewed = undefined;
    @observable accessor isEmpty = false;
    @observable accessor facilityOrderTemplatesGroupByPatient = [];
    @observable accessor isInventoryRequestSent = false;
    @observable accessor hideInventoryEmailButton = false;
    @observable accessor hasValidEmailType = false;
    @observable accessor templateExpanded = { id: null, expanded: false };

    // @observable facilityOrderStatus;
    // @observable disabled = false;
    // @observable disabledSendOrder = false;
    // @observable facilityOrderPatients = [];
    // @observable pickTicketHeaderStatus;
    // @observable emailType;

    tabItems = [{ abrv: 'in-progress', name: 'In Progress' }, { abrv: 'discharge', name: 'Discharges' }, { abrv: 'intake-reviewed', name: 'Intake Reviewed' }];
    questions = [{ id: "0", name: "Insurance questions" }, { id: "1", name: "Product questions" }];
    statuses = [{ id: "Hospital" }, { id: "Discharged" }, { id: "Expired" }, { id: "Active" }];

    constructor(rootStore) {
        super(rootStore);

        this.id = rootStore.routerStore.routerState.params.id;
        this.isAdmin = this.rootStore.userStore.user.roles.includes("Administrators");
        this.pageName = 'usi';

        this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        this.lookupService = new LookupService(rootStore.application.baasic.apiClient);
        this.itemCategoryService = new ItemCategoryService(rootStore.application.baasic.apiClient);
        this.nikoPatientDetailService = new NikoPatientDetailService(rootStore.application.baasic.apiClient);
        this.patientTemplateService = new NikoPatientTemplateService(rootStore.application.baasic.apiClient);
        this.patientTemplateItemService = new NikoPatientTemplateItemService(rootStore.application.baasic.apiClient);
        this.facilityOrderStatusService = new FacilityOrderStatusService(rootStore.application.baasic.apiClient);
        this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
        this.historyService = new HistoryService(rootStore.application.baasic.apiClient);

        this.questionsStore = new BaasicDropdownStore(
            { multi: true, filterable: false },
            {
                fetchFunc: () => {
                    return this.questions;
                },
            }
        );
        this.itemCategoryStore = new BaasicDropdownStore(
            { multi: true, filterable: true, initFetch: false },
            {
                fetchFunc: async (term) => {
                    const response = await this.itemCategoryService.find({ searchQuery: term, rpp: 100 });
                    return response.data.item.filter(i => this.facilityOrder.isEnteralWeek ? i.abrv === "enteral" : (i.abrv === "enteral" || i.abrv === "respiratory" || i.abrv === "urological" || i.abrv === "ostomy"));
                },
            }
        );

        this.statusConfirmModal = new ModalParams({ onClose: null });
        this.statusConfirmModal.onConfirm = async () => { await this.setUSIntakeStatusStarted(); this.statusConfirmModal.close(); };
        this.statusConfirmModal.onCancel = () => { this.statusConfirmModal.close() };
        this.statusConfirmModal.yesLabel = 'MODAL.START_ANYWAYS_LABEL';
        this.statusConfirmModal.noLabel = 'MODAL.CANCEL_LABEL';
        this.statusConfirmModal.swapButtons = true;

        this.nikoPatientInsuranceQuestionModal = new ModalParams({});
        this.nikoPatientInsuranceInfoNoteModal = new ModalParams({});
        this.nikoPatientEligibilityStatusNoteModal = new ModalParams({});
        this.nikoTemplateCreateModal = new ModalParams({});
        this.nikoTemplateMissingProductNoteModal = new ModalParams({});
        this.nikoTemplateInvoiceNoteModal = new ModalParams({});
        this.patientTemplateDoNotSupplyModal = new ModalParams({});
        this.patientTemplateDiscontinuedModal = new ModalParams({});
        this.nikoPatientStatusModal = new ModalParams({});
        this.patientTemplateDeleteModal = new ModalParams({});
        this.nikoPatientTemplateItemCalculationModal = new ModalParams({});
        this.nikoFacilityOrderUSIntakeClinicalInformationModal = new ModalParams({});
        this.nikoFacilityOrderReasonForChangeModal = new ModalParams({});
        this.nikoPatientTemplateItemNewFlowDeleteQuestionModal = new ModalParams({});
        this.patientTemplateNoteModal = new ModalParams({});
        this.nikoCreateNewPatientModal = new ModalParams({});

        this.templateChangeConfirmModal = new ModalParams({ onClose: null });
        this.templateChangeConfirmModal.onConfirm = async () => { this.templateChangeConfirmModal.close(); };
        this.templateChangeConfirmModal.yesLabel = 'MODAL.ACKNOWLEDGE';
        this.templateChangeConfirmModal.doNotShowCancel = true;

        // this.extraSuppliesApprovalRequiredModal = new ModalParams({ onClose: null });
        // this.extraSuppliesApprovalRequiredModal.yesLabel = 'MODAL.YES';
        // this.extraSuppliesApprovalRequiredModal.onCancel = () => { this.extraSuppliesApprovalRequiredModal.close() };
        // this.extraSuppliesApprovalRequiredModal.noLabel = 'MODAL.CANCEL_LABEL';
        // this.extraSuppliesApprovalRequiredModal.swapButtons = true;

        this.nikoFacilityOrderNewFlowExtraSuppliesAddModal = new ModalParams({});
        this.nikoFacilityOrderUSIntakeFindAndReplaceModal = new ModalParams({});
        // this.createFacilityOrderTemplateUSIntakeNewFlowModal = new ModalParams({});
        // this.facilityOrderTemplateItemNewFlowCalculationModal = new ModalParams({});
        // this.facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal = new ModalParams({});
        // this.facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal = new ModalParams({});
        // this.facilityOrderTemplateNewFlowInvoiceNoteModal = new ModalParams({});
        // this.facilityOrderTemplateDoNotSupplyModal = new ModalParams({});
        // this.facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal = new ModalParams({});
        // this.facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal = new ModalParams({});
        // this.facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal = new ModalParams({});
        // this.facilityOrderPatientNewFlowInsuranceEditModal = new ModalParams({});
        // this.facilityOrderPatientNewFlowInsuranceNoteModal = new ModalParams({});

        // this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        // this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        // this.facilityOrderTemplateNewFlowService = new FacilityOrderTemplateNewFlowService(rootStore.application.baasic.apiClient);
        // this.facilityOrderTemplateItemService = new FacilityOrderTemplateItemService(rootStore.application.baasic.apiClient);
        // this.localPatientService = new LocalPatientService(rootStore.application.baasic.apiClient);
        this.inventoryRequestService = new InventoryRequestService(rootStore.application.baasic.apiClient);

        document.addEventListener('click', (e) => {
            if (!this.templateExpanded.id) return;
            const elements = [
                ...document.querySelectorAll(`[id="templateQuantity-${this.templateExpanded.id}"]`),
                ...document.querySelectorAll(`[id="orderQuantity-${this.templateExpanded.id}"]`),
            ];
            const clickedOutside = elements.length === 0 || elements.every((el) => !el.contains(e.target));
            if (clickedOutside) {
                this.templateExpanded.expanded = false;
            }
        });

        this.statusStore = new BaasicDropdownStore(
            {
                multi: false,
                filterable: false,
                textField: "id"
            },
            {
                fetchFunc: () => {
                    return this.statuses;
                },
            }
        );

        this.queryUtility = new QueryUtility(this.rootStore, async filter => {
            await this.fetchFacilityOrderData(filter);
        }, {});

        this.fetch([
            this.initialize()
        ]);
    }

    async initialize() {
        await this.getFacilityOrder();
        await this.getLookups();
        await this.getData();
        // await this.itemCategoryStore.filterAsync();
        // await this.initializeFacilityOrderPatients();
        // await this.initializePickTicketHeader();
        // await this.initializeStatus();
    }

    @action.bound
    async getFacilityOrder() {
        const facilityOrder = (await this.facilityOrderService.get(this.id, { embed: 'Facility,FacilityOrderStatuses' })).data;//Facility.FacilityAreaOfCares,Facility.Corporate_
        this.rootStore.titleStore.setTitle(`US Intake - ${facilityOrder.facility.name}`);
        //     const masterPatient = (await this.localPatientService.getByPatientKey(this.facilityOrder.facility.masterPatientId, { fields: 'id' })).data;
        //     this.masterPatientId = masterPatient ? masterPatient.id : undefined;

        const hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
        const emailType = (await this.inventoryRequestService.checkIsNikoInventoryRequestEligible(facilityOrder.id)).data;
        runInAction(() => {
            this.facilityOrder = facilityOrder;
            this.isInventoryRequestSent = facilityOrder.isInventoryRequestSent;
            this.hideInventoryEmailButton = hideInventoryEmailButton;
            this.emailType = emailType;
            this.hasValidEmailType = emailType != "None";
        });
    }

    @action.bound
    async getLookups() {
        this.lookups = await this.lookupService.getLookups("FacilityScheduleType,NewFlowStatus,ImportHeaderStatus,ImportAction,ItemCategory,SubCategory,SpecialtyType,DefaultItemType"); //,ImportHeaderStatus,ItemCategory,SubCategory,ImportDetailStatus,
        this.orderingTypeId = this.lookups.facilityScheduleType.find((s) => s.abrv === 'ordering').id;
        this.inProgressStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'in-progress').id;
        this.changeStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'change').id;
        this.noChangeStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'no-change').id;
        this.dischargeStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'discharge').id;
        this.activeNewFlowStatusIds = `${this.inProgressStatusId},${this.changeStatusId},${this.noChangeStatusId}`;

        this.insertImportActionId = this.lookups.importAction.find((s) => s.abrv === 'insert').id;
        this.deleteImportActionId = this.lookups.importAction.find((s) => s.abrv === 'delete').id;
        this.updateImportActionId = this.lookups.importAction.find((s) => s.abrv === 'update').id;

        this.ostomyItemCategoryId = this.lookups.itemCategory.find((s) => s.abrv === 'ostomy').id;
        this.enteralItemCategoryId = this.lookups.itemCategory.find((s) => s.abrv === 'enteral').id;
        this.respiratorySubCategoryId = this.lookups.subCategory.find((s) => s.abrv === 'Respiratory---trachs-supply').id;
        this.trachTubeSubCategoryId = this.lookups.subCategory.find((s) => s.abrv === 'Trach-Tube').id;

        this.syringeDefaultItemTypeId = this.lookups.defaultItemType.find((s) => s.abrv === 'syringe').id;
        //     this.intakeReviewedNewFlowStatusId = this.lookups.newFlowStatus.find((s) => s.abrv === 'intake-reviewed').id;
        //     this.failedImportDetailStatusId = this.lookups.importDetailStatus.find((s) => s.abrv === 'failed').id;
        //     this.importedImportDetailStatusId = this.lookups.importDetailStatus.find((s) => s.abrv === 'imported').id;

        const eligibilityStatusService = new EligibilityStatusService(this.rootStore.application.baasic.apiClient);
        this.eligibilityStatuses = (await eligibilityStatusService.find({ rpp: 100 })).data.item;
    }

    @action.bound
    async getData() {
        this.page = "us-intake";
        this.isInventoryStepAllowed = (await this.facilityOrderService.isNikoInventoryStepAllowed(this.id)).data;
        await this.itemCategoryStore.filterAsync();

        let queryParams = this.rootStore.routerStore.routerState.queryParams;
        const selectedStatus = _.find(this.lookups.newFlowStatus, s => {
            return queryParams && queryParams.intakeStatusIds && s.id === queryParams.intakeStatusIds;
        });
        const selectedStatusAbrv = selectedStatus ? selectedStatus.abrv : (this.usIntakeStatus && this.usIntakeStatus.completedOn && !(await this.hasAnyTemplateInProgress())) ? 'intake-reviewed' : 'in-progress';
        this.setStatus(selectedStatusAbrv);
    }

    @action.bound
    async hasAnyTemplateInProgress() {
        let params = {
            facilityOrderId: this.id,
            intakeStatusIds: this.activeNewFlowStatusIds,
            isUsIntakeReviewed: false,
            pageSize: 1,
            fields: 'id',
        }
        return (await this.patientTemplateService.find(params)).data.item.some(x => x.id);
    }

    @action.bound
    setStatus(statusAbrv) {
        if (this.selectedStatusAbrv == statusAbrv || this.fetchingData) {
            return;
        }
        // this.isEmpty = false;
        // this.loadingTemplates = true;
        // this.facilityOrderTemplatesGroupByPatient = [];
        this.selectedStatusAbrv = statusAbrv;
        this.queryUtility.filter.set('intakeStatusIds', this.selectedStatusAbrv === "discharge" ? this.dischargeStatusId : this.activeNewFlowStatusIds);
        this.queryUtility.fetch();
    }

    @action.bound
    async fetchFacilityOrderData(filter) {
        runInAction(() => {
            this.fetchingData = true;
        });
        var itemCategoryIds = _.map(this.itemCategories, (i => { return i.id }));
        let params = {
            ...filter,
            facilityOrderId: this.id,
            isUsIntakeReviewed: this.selectedStatusAbrv == "in-progress" ? false : this.selectedStatusAbrv == "intake-reviewed" ? true : undefined,
            itemCategoryIds: (itemCategoryIds && itemCategoryIds.length > 0) ? itemCategoryIds : undefined,
            showInsuranceQuestionPatients: this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0"),
            showMissingProductNoteTemplates: this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1"),
            pageSize: 10000,
            embed: 'NikoPatientDetail,PatientTemplateItems,SubCategory,NikoPatientDetail.EligibilityStatus,NikoPatientDetail.NikoPatientDetailInsurances,OrderingDoctor,PatientTemplateDiagnosisCodes,PatientTemplateMissingDocuments,ClinicalStatus,ItemCategory', //'FacilityOrderTemplateItems,Patient,,,ImportReference,NewFlowStatus,IsFacilityOrderTemplateItemInitial,,ReviewUSIntakeValidations',
            orderBy: "SubCategory",
            orderDirection: "asc",
        }

        let responseData = (await this.patientTemplateService.find(params)).data.item;
        const groupedByPatientDetail = _.groupBy(responseData, t => t.nikoPatientDetail.id);
        let nikoPatientDetails = Object.values(groupedByPatientDetail).map(patientTemplates => ({
            ...patientTemplates[0].nikoPatientDetail,
            nikoPatient: { ...patientTemplates[0].nikoPatientDetail.nikoPatient, dateOfBirth: toUTCDate(patientTemplates[0].nikoPatientDetail.nikoPatient.dateOfBirth) },
            disabled: this.selectedStatusAbrv == "in-progress" && patientTemplates[0].nikoPatientDetail.status === 'Hospital',
            patientTemplates: patientTemplates.map(t => ({
                ...t,
                nikoPatientDetail: undefined,
                disabled: false,
                itemsVisible: false
            }))
        }));

        runInAction(() => {
            nikoPatientDetails.forEach(nikoPatientDetail => {
                nikoPatientDetail.tempInsuranceInfoNote = nikoPatientDetail.insuranceInfoNote;
                nikoPatientDetail.history = { userName: '', eventDate: null, fieldName: '' };
                this.setHasHistory(nikoPatientDetail);
                this.getPatientStatusButtonClassName(nikoPatientDetail);
                nikoPatientDetail.patientTemplates.forEach(template => {
                    template.tempNote = template.note;
                    template.patientTemplateItems && template.patientTemplateItems.forEach(item => {
                        item.savedQuantity = item.quantity;
                        item.savedSalesOrderQuantity = item.salesOrderQuantity;
                        item.savedNote = item.note;
                        item.history = item.history || { userName: '', eventDate: null, fieldName: '', action: '' };
                    });
                    template.isDifferentQty = template.patientTemplateItems && template.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
                });
            });
            this.nikoPatientDetails = nikoPatientDetails;
        });

        if (this.usIntakeStatus && !this.usIntakeStatus.completedOn && this.selectedStatusAbrv != "intake-reviewed") {
            this.checkIsReviewed(false);
        }

        if (((this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id)) || this.itemCategories.some(x => x.id)) && this.nikoPatientDetails.length === 0) {
            this.rootStore.notificationStore.warning("No templates found under selected filter");
        }
        runInAction(() => {
            this.fetchingData = false;
        });
    }

    @action.bound
    async fetchPatientTemplateByPatient(nikoPatientDetailId) {
        if (this.usIntakeStatus && !this.usIntakeStatus.completedOn && this.selectedStatusAbrv != "intake-reviewed") {
            await this.checkIsReviewed(false);
        }

        const itemCategoryIds = _.map(this.itemCategories, (i => { return i.id }));
        let params = {
            intakeStatusIds: this.queryUtility.filter.intakeStatusIds,
            facilityOrderId: this.id,
            isUsIntakeReviewed: this.selectedStatusAbrv == "in-progress" ? false : this.selectedStatusAbrv == "intake-reviewed" ? true : undefined,
            itemCategoryIds: (itemCategoryIds && itemCategoryIds.length > 0) ? itemCategoryIds : undefined,
            showInsuranceQuestionPatients: this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "0"),
            showMissingProductNoteTemplates: this.selectedStatusAbrv != "discharge" && this.selectedQuestions.some(x => x.id === "1"),
            pageSize: 10000,
            embed: 'NikoPatientDetail,PatientTemplateItems,SubCategory,NikoPatientDetail.EligibilityStatus,NikoPatientDetail.NikoPatientDetailInsurances,OrderingDoctor,PatientTemplateDiagnosisCodes,PatientTemplateMissingDocuments,ClinicalStatus,ItemCategory', //'FacilityOrderTemplateItems,Patient,,,ImportReference,NewFlowStatus,IsFacilityOrderTemplateItemInitial,,ReviewUSIntakeValidations',
            orderBy: "SubCategory",
            orderDirection: "asc",
            nikoPatientDetailId: nikoPatientDetailId
        }

        let responseData = (await this.patientTemplateService.find(params)).data.item;
        const groupedByPatientDetail = _.groupBy(responseData, t => t.nikoPatientDetail.id);
        let nikoPatientDetails = Object.values(groupedByPatientDetail).map(patientTemplates => ({
            ...patientTemplates[0].nikoPatientDetail,
            nikoPatient: { ...patientTemplates[0].nikoPatientDetail.nikoPatient, dateOfBirth: toUTCDate(patientTemplates[0].nikoPatientDetail.nikoPatient.dateOfBirth) },
            disabled: false,
            patientTemplates: patientTemplates.map(t => ({
                ...t,
                nikoPatientDetail: undefined,
                disabled: false,
                itemsVisible: false
            }))
        }));

        nikoPatientDetails.forEach(nikoPatientDetail => {
            nikoPatientDetail.tempInsuranceInfoNote = nikoPatientDetail.insuranceInfoNote;
            nikoPatientDetail.history = { userName: '', eventDate: null, fieldName: '' };
            this.setHasHistory(nikoPatientDetail);
            this.getPatientStatusButtonClassName(nikoPatientDetail);
            nikoPatientDetail.patientTemplates.forEach(template => {
                template.tempNote = template.note;
                template.patientTemplateItems && template.patientTemplateItems.forEach(item => {
                    item.savedQuantity = item.quantity;
                    item.savedSalesOrderQuantity = item.salesOrderQuantity;
                    item.savedNote = item.note;
                    item.history = item.history || { userName: '', eventDate: null, fieldName: '', action: '' };
                });
                template.isDifferentQty = template.patientTemplateItems && template.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
            });
        });

        let index = this.nikoPatientDetails.findIndex(x => x.id == nikoPatientDetailId);

        if (nikoPatientDetails && nikoPatientDetails[0]) {
            runInAction(() => {
                if (index != -1) {
                    const existing = this.nikoPatientDetails[index];
                    // Preserve UI state from existing templates
                    nikoPatientDetails[0].patientTemplates.forEach(newTemplate => {
                        const oldTemplate = existing.patientTemplates && existing.patientTemplates.find(t => t.id == newTemplate.id);
                        if (oldTemplate) {
                            newTemplate.itemsVisible = oldTemplate.itemsVisible;
                        }
                    });
                    this.nikoPatientDetails.splice(index, 1, nikoPatientDetails[0]);
                }
                else {
                    this.nikoPatientDetails.push(nikoPatientDetails[0]);
                }
            });
        }
        else if (index != -1) {
            this.nikoPatientDetails.splice(index, 1);
        }

        this.shouldAutoNavigateToDischargesTab();
    }

    @action.bound
    async fetchPatientTemplateIntakeStatusById(patientTemplate) {
        if (this.selectedStatusAbrv == "discharge" || !patientTemplate) {
            return;
        }
        let responseData = (await this.patientTemplateService.get(patientTemplate.id, { fileds: 'IntakeStatusId' })).data;
        if (patientTemplate.intakeStatusId != responseData.intakeStatusId) {
            patientTemplate.intakeStatusId = responseData.intakeStatusId;
        }
    }

    @action.bound
    async fetchNikoPatientDetailInsuranceStatusById(nikoPatientDetail) {
        let responseData = (await this.nikoPatientDetailService.get(nikoPatientDetail.id, { fileds: 'InsuranceStatusId' })).data;
        if (nikoPatientDetail.insuranceStatusId != responseData.insuranceStatusId) {
            nikoPatientDetail.insuranceStatusId = responseData.insuranceStatusId;
        }
    }

    @action.bound
    async fetchPatientTemplateItemsById(nikoPatientDetailId, patientTemplateId) {
        const index = this.nikoPatientDetails.findIndex(x => x.id == nikoPatientDetailId);
        if (index == -1)
            return;
        var patientTemplate = this.nikoPatientDetails[index].patientTemplates && this.nikoPatientDetails[index].patientTemplates.find(x => x.id == patientTemplateId);
        if (patientTemplate && patientTemplate.patientTemplateItems) {
            let responseData = (await this.patientTemplateService.get(patientTemplateId, { embed: 'PatientTemplateItems' })).data;
            if (responseData.patientTemplateItems) {
                runInAction(() => {
                    Object.assign(patientTemplate.patientTemplateItems, responseData.patientTemplateItems);
                    patientTemplate.patientTemplateItems.forEach(item => {
                        item.savedQuantity = item.quantity;
                        item.savedSalesOrderQuantity = item.salesOrderQuantity;
                        item.savedNote = item.note;
                    });
                    patientTemplate.isDifferentQty = patientTemplate.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
                });
            }
        }
    }

    @action.bound
    setHasHistory(nikoPatientDetail) {
        this.createInsuranceCompareModel(nikoPatientDetail);
        nikoPatientDetail.hasHistory = !nikoPatientDetail.isNew &&
            (
                (nikoPatientDetail.primaryActive.insuranceId.current != nikoPatientDetail.primaryActive.insuranceId.initial || nikoPatientDetail.primaryActive.policyNo.current != nikoPatientDetail.primaryActive.policyNo.initial) ||
                (nikoPatientDetail.secondaryActive.insuranceId.current != nikoPatientDetail.secondaryActive.insuranceId.initial || nikoPatientDetail.secondaryActive.policyNo.current != nikoPatientDetail.secondaryActive.policyNo.initial) ||
                (nikoPatientDetail.primaryInactive.insuranceId.current && (nikoPatientDetail.primaryInactive.insuranceId.current != nikoPatientDetail.primaryInactive.insuranceId.initial || nikoPatientDetail.primaryInactive.policyNo.current != nikoPatientDetail.primaryInactive.policyNo.initial)) ||
                (nikoPatientDetail.secondaryInactive.insuranceId.current && (nikoPatientDetail.secondaryInactive.insuranceId.current != nikoPatientDetail.secondaryInactive.insuranceId.initial || nikoPatientDetail.secondaryInactive.policyNo.current != nikoPatientDetail.secondaryInactive.policyNo.initial)) ||
                (nikoPatientDetail.eligibilityStatusId != (nikoPatientDetail.initialNikoPatientDetail ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatusId : "")) ||
                nikoPatientDetail.patientTemplates.some(pt => !pt.isNew && pt.isPriorAuthNeeded != (pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded))
            );
    }

    @action.bound
    createInsuranceCompareModel(nikoPatientDetail) {
        nikoPatientDetail.primaryActive = {
            id: { initial: null, current: null },
            insuranceId: { initial: null, current: null },
            insurance: { initial: null, current: null },
            policyNo: { initial: null, current: null },
            startDate: { initial: null, current: null },
            endDate: { initial: null, current: null },
        };
        nikoPatientDetail.primaryInactive = {
            id: { initial: null, current: null },
            insuranceId: { initial: null, current: null },
            insurance: { initial: null, current: null },
            policyNo: { initial: null, current: null },
            startDate: { initial: null, current: null },
            endDate: { olinitiald: null, current: null },
        };
        nikoPatientDetail.secondaryActive = {
            id: { initial: null, current: null },
            insuranceId: { initial: null, current: null },
            insurance: { initial: null, current: null },
            policyNo: { initial: null, current: null },
            startDate: { initial: null, current: null },
            endDate: { initial: null, current: null },
        };
        nikoPatientDetail.secondaryInactive = {
            id: { initial: null, current: null },
            insuranceId: { initial: null, current: null },
            insurance: { initial: null, current: null },
            policyNo: { initial: null, current: null },
            startDate: { initial: null, current: null },
            endDate: { initial: null, current: null },
        };

        const fill = (list, targetKey) => {
            if (!list) return;
            const map = targetKey === 'current' ?
                { type: 'type', status: 'status', id: 'id', insuranceId: 'insuranceId', insurance: 'insurance', policyNo: 'policyNo', startDate: 'startDate', endDate: 'endDate' }
                :
                { type: 'Type', status: 'Status', id: 'Id', insuranceId: 'InsuranceId', insurance: 'Insurance', policyNo: 'PolicyNo', startDate: 'StartDate', endDate: 'EndDate' };

            list.forEach(i => {
                const key = `${i[map.type].toLowerCase()}${i[map.status]}`;
                const target = nikoPatientDetail[key];
                if (!target) return;
                target.id[targetKey] = i[map.id];
                target.insuranceId[targetKey] = i[map.insuranceId];
                target.insurance[targetKey] = i[map.insurance];
                target.policyNo[targetKey] = i[map.policyNo];
                target.startDate[targetKey] = i[map.startDate];
                target.endDate[targetKey] = i[map.endDate];
            });
        };

        fill(nikoPatientDetail.nikoPatientDetailInsurances, 'current');
        if (nikoPatientDetail.initialNikoPatientDetail) {
            fill(nikoPatientDetail.initialNikoPatientDetail.NikoPatientDetailInsurances, 'initial');
            resolveInitialEligibilityStatus(nikoPatientDetail.initialNikoPatientDetail, this.eligibilityStatuses);
        }
    }

    @action.bound
    getPatientStatusButtonClassName(nikoPatientDetail, status = null) {
        nikoPatientDetail.hospitalClassName = "";
        nikoPatientDetail.dischargedClassName = "";
        nikoPatientDetail.expiredClassName = "";
        nikoPatientDetail.activeClassName = "";

        this.statuses.filter(i => !status || i.id === status).forEach((item) => {
            if (this.selectedStatusAbrv === "in-progress") {
                if (item.id === "Hospital" && nikoPatientDetail.status === 'Hospital') {
                    nikoPatientDetail.hospitalClassName = "is-active--alt"
                }
                else if (item.id === "Active" && nikoPatientDetail.status !== 'Hospital') {
                    nikoPatientDetail.activeClassName = "is-active";
                }
            }
            else if (this.selectedStatusAbrv === "discharge") {
                if (item.id === "Hospital" && nikoPatientDetail.status === 'Hospital') {
                    nikoPatientDetail.hospitalClassName = "is-active";
                }
                else if (item.id === "Discharged" && nikoPatientDetail.status === 'Discharged') {
                    nikoPatientDetail.dischargedClassName = "is-active";
                }
                else if (item.id === "Expired" && nikoPatientDetail.status === 'Expired') {
                    nikoPatientDetail.expiredClassName = "is-active";
                }
                else if (item.id === "Active" && nikoPatientDetail.status !== 'Hospital' && nikoPatientDetail.status !== 'Discharged' && nikoPatientDetail.status !== 'Expired') {
                    nikoPatientDetail.activeClassName = "is-active";
                }
            }
            else if (this.selectedStatusAbrv === "intake-reviewed" && item.id === "Active") {
                nikoPatientDetail.activeClassName = "is-active";
            }
        });
    }

    @action.bound
    async goToFacilityPreview() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", this.facilityOrder.facilityId)}`);
    }

    @action.bound
    async goToFacilityCalendar() {
        window.open(`${this.rootStore.routerStore.findRoute('master.app.main.schedule.calendar').pattern}?facilityId=${this.facilityOrder.facilityId}&calendarTypeId=${this.orderingTypeId}`);
    }

    @action.bound
    async startUSIntakeStatus() {
        // await this.getFacilityOrderStatus();
        const insuranceReviewStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'insurance-review');
        const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
        if (!(initialIntakeStatus && initialIntakeStatus.completedOn) || !(insuranceReviewStatus && insuranceReviewStatus.completedOn)) {
            this.statusConfirmModal.open({
                message: !(initialIntakeStatus && initialIntakeStatus.completedOn) ? "This facility order has not been completed by the Initial Intake and the Insurance Review departments. Once you start US Intake, they will no longer be able to access their workflow." : "This facility order has not been completed by the Insurance Review department. Once you start US Intake, they will no longer be able to access their workflow."
            });
        }
        else {
            await this.setUSIntakeStatusStarted();
        }
    }

    @action.bound
    async setUSIntakeStatusStarted() {
        if (this.usIntakeStatus) {
            return;
        }

        this.disabled = true;
        try {
            // const initialIntakeStatus = this.facilityOrder.facilityOrderStatuses.find(i => i.status.abrv === 'initial-intake');
            // if (initialIntakeStatus && !initialIntakeStatus.completedOn) {
            //     var result = await this.facilityOrderTemplateService.updateFacilityOrderTemplateIntakeStatuses({ facilityOrderId: this.facilityOrder.id });
            //     if (result.statusCode === 200) {
            //         this.queryUtility.fetch();
            //     }
            // }
            const status = this.lookups.importHeaderStatus.find(i => i.abrv === 'us-intake');
            await this.facilityOrderStatusService.create({ facilityOrderId: this.facilityOrder.id, statusId: status.id, startedOn: new Date(), startedByUserId: this.rootStore.userStore.user.id });
            // if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
            //     await this.checkIsReviewed();
            // }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
        finally {
            await this.getFacilityOrderStatus();
            this.disabled = false;
        }
    }

    @action.bound
    async setUSIntakeStatusComplete() {
        if (!this.usIntakeStatus || this.usIntakeStatus.completedOn) {
            return;
        }

        this.disabled = true;
        try {
            const request = { ...this.usIntakeStatus, completedOn: new Date(), completedByUserId: this.rootStore.userStore.user.id };
            await this.facilityOrderStatusService.update(request);
            // await this.openClinicalReviewPage();
            // if (this.selectedStatusAbrv == "discharge" || this.checkIsEmpty()) {
            //     await this.checkIsReviewed();
            // }
        }
        catch (err) {
            this.rootStore.notificationStore.error("The facility order status has already been updated. Please reload the page.");
        }
        finally {
            await this.getFacilityOrderStatus();
            this.disabled = false;
        }
    }

    @action.bound
    async getFacilityOrderStatus() {
        var statuses = await this.facilityOrderStatusService.find({ facilityOrderId: this.facilityOrder.id, embed: "Status,StartedByUser,CompletedByUser" });
        runInAction(() => {
            this.facilityOrder.facilityOrderStatuses.replace(statuses.data.item);
        });
        this.refreshKey = uuid();
    }

    @action.bound
    filterByQuestion(selected) {
        this.selectedQuestions = selected.value;
        // this.filterChange = true;
        this.queryUtility.fetch();
    }

    @action.bound
    filterByCategory(selected) {
        this.itemCategories = selected.value;
        // this.filterChange = true
        this.queryUtility.fetch();
    }

    @action.bound
    handleActionDropDownItemsOnClick(e) {
        // if (e.item.text === "New Patient") {
        //     this.goToCreatePatient();
        // }
        if (e.item.text === "Find and Replace") {
            this.openNikoFacilityOrderUSIntakeFindAndReplaceModal();
        }
        // if (e.item.text === "Export FO CSV") {
        //     this.downloadFacilityOrderCsv();
        // }
        if (e.item.text === "Inventory Request Email") {
            this.openInventoryRequestWindowThroughActionsMenu();
        }
        else if (e.item.text === "Inventory Report") {
            this.downloadInventoryReport();
        }
        else {
            return e;
        }
    }
    isMasterPatient = (nikoPatientDetail) => {
        return this.facilityOrder && this.facilityOrder.facility
            && this.facilityOrder.facility.nikoMasterPatientId
            && this.facilityOrder.facility.nikoMasterPatientId == nikoPatientDetail.nikoPatientId;
    }

    isCheckingDeliveryLocation = false;

    @action.bound
    async openCreateNewPatientModal() {
        if (this.isCheckingDeliveryLocation) {
            return;
        }
        const facilityId = this.facilityOrder ? this.facilityOrder.facilityId : null;
        if (facilityId) {
            this.isCheckingDeliveryLocation = true;
            let loadingToastId = null;
            const loadingToastTimeout = setTimeout(() => {
                loadingToastId = this.rootStore.notificationStore.warning("Checking Facility Delivery Location in Niko...", false);
            }, 1000);
            let hasDeliveryLocation = true;
            try {
                const facilityService = new FacilityService(this.rootStore.application.baasic.apiClient);
                const response = await facilityService.hasNikoDeliveryLocation(facilityId);
                hasDeliveryLocation = !(response && response.data && !response.data.hasDeliveryLocation);
            } finally {
                clearTimeout(loadingToastTimeout);
                if (loadingToastId !== null) {
                    this.rootStore.notificationStore.dismiss(loadingToastId);
                }
                this.isCheckingDeliveryLocation = false;
            }
            if (!hasDeliveryLocation) {
                return this.rootStore.notificationStore.error("Action not allowed: this Facility has no Delivery Location in Niko. Add the Delivery Location in Niko and try again.");
            }
        }
        this.nikoCreateNewPatientModal.open({
            facilityOrderId: this.id,
            facilityOrder: this.facilityOrder,
            facilityId: facilityId,
            fetchPatientTemplates: async () => { this.queryUtility.fetch(); },
            pageName: this.pageName,
            pageType: 'USI',
        });
    }

    @action.bound
    async openNikoTemplateCreateModal(nikoPatientDetail) {
        const isMasterPatient = this.isMasterPatient(nikoPatientDetail);

        if (isMasterPatient) {
            await this.nikoFacilityOrderNewFlowExtraSuppliesAddModal.open({
                facilityOrderId: this.facilityOrder.id,
                sendAgoraPo: this.facilityOrder.facility.sendAgoraPo,
                skipAutoItems: true,
                fetchData: () => this.fetchPatientTemplateByPatient(nikoPatientDetail.id)
            });
        } else {
            await this.nikoTemplateCreateModal.open({
                nikoPatientDetail: nikoPatientDetail,
                fetchPatientTemplates: () => this.fetchPatientTemplateByPatient(nikoPatientDetail.id),
                pageName: this.pageName,
                tabName: this.selectedStatusAbrv
            });
        }
    }

    @action.bound
    async openNikoPatientStatusModal(nikoPatientDetail, status) {
        this.nikoPatientStatusModal.open({
            status: status,
            nikoPatientDetail: nikoPatientDetail,
            pageName: this.pageName,
            tabName: this.selectedStatusAbrv,
            additionalMessage: this.selectedStatusAbrv == "discharge" && status == 'Active' && 'Patient will be reviewed upon activation. Please confirm that you’ve applied all necessary updates to the patient’s insurance and templates.',
            getNikoPatient: () => this.fetchPatientTemplateByPatient(nikoPatientDetail.id)
        });
    }

    @action.bound
    async reviewPatientTemplates(nikoPatientDetail, patientTemplateId, isReview) { //(statusAbrv, templateId, isReview) {
        nikoPatientDetail.disabled = true;
        try {
            // const status = this.lookups.newFlowStatus.find((s) => s.abrv === statusAbrv);
            // const updatedItems = _.map(this.facilityOrderTemplates.filter((item) => !templateId || item.id === templateId), (item) => {
            //     return {
            //         id: item.id,
            //         inactiveReasonId: item.inactiveReasonId,
            //         isReviewed: !isReview ? false : (isReview && templateId ? isReview : (isReview ? (item.newFlowUSIntakeStatusId === this.pageViewStore.noChangeStatusId ? true : false) : item.isReviewed)),
            //         newFlowStatusId: item.newFlowStatusId,
            //         newFlowStatusUpdatedByUserId: this.rootStore.userStore.user.id,
            //         newFlowInsuranceStatusId: statusAbrv === "intake-reviewed" || templateId ? item.newFlowInsuranceStatusId : status.id,
            //         portalNote: item.portalNote,
            //         newFlowUSIntakeStatusId: !isReview ? item.newFlowStatusId : (isReview && !templateId ? (item.newFlowUSIntakeStatusId === this.pageViewStore.noChangeStatusId ? status.id : item.newFlowUSIntakeStatusId) : status.id),
            //         changeTemplateStatus: isReview && (item.newFlowStatusId == this.pageViewStore.inProgressStatusId || item.newFlowStatusId == this.pageViewStore.changeStatusId)
            //     };
            // });

            // this.pageViewStore.removeFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, templateId, isReview);
            const updatedItems = _.map(nikoPatientDetail.patientTemplates.filter((pt) => pt.id && (!patientTemplateId || pt.id == patientTemplateId)), (pt) => {
                return {
                    id: pt.id,
                    isReviewed: isReview,
                    pageName: this.pageName,
                };
            });
            const templateIds = updatedItems.map((item) => item.id);

            // ISG-871: run drainage bag / leg bag validations for the reviewed template(s) and surface the
            // resulting orange warning toasts. Only when reviewing (not un-reviewing) and only on the In Progress tab;
            // reviews on the Discharges tab must not trigger validation.
            let validationMessages = [];
            if (isReview && templateIds.length > 0 && this.selectedStatusAbrv === "in-progress") {
                const validationResponse = await this.patientTemplateService.drainageBagValidation(templateIds);
                validationMessages = (validationResponse && validationResponse.data && validationResponse.data.messages) || [];
            }

            await this.patientTemplateService.reviewPatientTemplate(updatedItems);
            await this.fetchPatientTemplateByPatient(nikoPatientDetail.id);

            validationMessages.forEach((message) => this.rootStore.notificationStore.warning(message));
            // if (isReview) {
            //     this.pageViewStore.fullReviewCheck(true);
            // }
        }
        catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to review the template.");
        }
        finally {
            nikoPatientDetail.disabled = false;
        }
    }

    @action.bound
    async reviewAllPatientTemplates() {
        this.disabled = true;
        try {
            const patientTemplates = this.nikoPatientDetails.reduce((result, nikoPatientDetail) => {
                result = result.concat(nikoPatientDetail.patientTemplates.filter(obj => obj !== undefined && !obj.isUsIntakeReviewed)); //&& !((nikoPatientDetail.isNew || nikoPatientDetail.insuranceStatusId === this.changeStatusId) && !nikoPatientDetail.isInsuranceReviewed)
                return result;
            }, []);

            if (patientTemplates && patientTemplates.length > 0) {
                const updatedItems = _.map(patientTemplates, (pt) => {
                    return {
                        id: pt.id,
                        isReviewed: true,
                        pageName: this.pageName,
                    };
                });
                // ISG-871: this is the Discharges tab "Review All" — drainage bag validation must NOT run here.
                await this.patientTemplateService.reviewPatientTemplate(updatedItems);
            }

        } catch (err) {
            this.rootStore.notificationStore.error("An unexpected error occurred while trying to update the template.", err);
        }
        finally {
            this.queryUtility.fetch();
            this.disabled = false;
        }
    }

    @action.bound
    changeItemsVisibility(patientTemplate) {
        patientTemplate.itemsVisible = !patientTemplate.itemsVisible;
    }

    @action.bound
    async openNikoPatientInsuranceQuestionModal(nikoPatientDetail) {
        this.nikoPatientInsuranceQuestionModal.open({
            nikoPatientDetail: nikoPatientDetail,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(nikoPatientDetail, true)
        });
    }

    @action.bound
    async openNikoPatientInsuranceInfoNoteModal(nikoPatientDetail) {
        this.nikoPatientInsuranceInfoNoteModal.open({
            nikoPatientDetail: nikoPatientDetail,
            setTempValue: (nikoPatientDetail) => { nikoPatientDetail.tempInsuranceInfoNote = nikoPatientDetail.insuranceInfoNote }
        });
    }

    @action.bound
    async updateNikoPatientInsuranceInfoNote(nikoPatientDetail, value, save = false) {
        nikoPatientDetail.tempInsuranceInfoNote = value;
        if (save) {
            nikoPatientDetail.insuranceInfoNote = nikoPatientDetail.tempInsuranceInfoNote;
            await this.updateInsuranceInfo(nikoPatientDetail);
        }
    }

    @action.bound
    async updateInsuranceInfo(nikoPatientDetail) {
        nikoPatientDetail.disabled = true;
        try {
            await this.nikoPatientDetailService.updatePatientInsuranceInfo(nikoPatientDetail);
        }
        catch (err) {
            this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occurred while trying to update patient Insurance Information.'));
            // await this.getNikoPatient();
        }
        finally {
            nikoPatientDetail.disabled = false;
        }
    }

    @action.bound
    async openNikoHealthPatient(remoteId) {
        window.open(`${this.rootStore.applicationStore.app.baasic.settings.nikoHealthBaseUrl}v2/#/patients/${remoteId}/demographics`);
    }

    @action.bound
    async checkIsReviewed(setStatus = true) {
        let params = {
            facilityOrderId: this.id,
            isUsIntakeReviewed: false,
            pageSize: 1,
            fields: 'id',
        }
        this.isReviewed = !(await this.patientTemplateService.find(params)).data.item.some(x => x.id);
        if (this.isReviewed) {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.isInventoryRequestSent = (await facilityOrderService.hasSentEmail(this.facilityOrder.id, "InventoryRequest")).data;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
            this.emailType = (await this.inventoryRequestService.checkIsNikoInventoryRequestEligible(this.facilityOrder.id)).data;
            this.hasValidEmailType = this.emailType != "None";
        }

        if (setStatus) {
            this.shouldAutoNavigateToDischargesTab();
        }
    }

    @action.bound
    shouldAutoNavigateToDischargesTab() {
        if (this.selectedStatusAbrv == "in-progress" && !this.isReviewed && this.usIntakeStatus && !this.usIntakeStatus.completedOn && this.nikoPatientDetails.length == 0) {
            this.setStatus('discharge');
        }
    }

    @action.bound
    async checkIsUSIntakeCompleted(showDischarges) {
        if (showDischarges && this.isEmpty && this.selectedStatusAbrv == "in-progress" && !this.isReviewed) {
            this.setStatus('discharge');
            this.isInventoryRequestSent = this.facilityOrder.isInventoryRequestSent;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
        }
    }

    @action.bound
    async checkIsReviewedTemplateStatusChange() {
        let params = {
            pageSize: 1,
            facilityOrderId: this.id,
            isReviewed: false,
            fields: "id"
        }

        if (this.facilityOrder.isEnteralWeek) {
            params = _.extend(params, {
                itemCategoryIds: [this.enteralItemCategoryId],
                masterPatientId: this.masterPatientId
            });
        }

        const response = await this.patientTemplateService.find(params);
        this.isReviewed = response.data.item && !response.data.item.some(i => i);
        if (this.isReviewed) {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            this.isInventoryRequestSent = (await facilityOrderService.hasSentEmail(this.facilityOrder.id, "InventoryRequest")).data;
            this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
            this.emailType = (await this.inventoryRequestService.checkIsNikoInventoryRequestEligible(this.facilityOrder.id)).data;
            this.hasValidEmailType = this.emailType != "None";
        }
    }

    @action.bound
    async openInventoryRequestWindow() {
        this.emailType = (await this.inventoryRequestService.checkIsNikoInventoryRequestEligible(this.facilityOrder.id)).data;
        this.hasValidEmailType = this.emailType != "None";
        window.open(`${this.rootStore.routerStore
            .findRoute('master.app.main.niko-facility-order.niko-inventory-request.new-flow-edit-email')
            .pattern.replace(":facilityOrderId", this.id)
            .replace(":inventoryRequestType", this.emailType)}?isNiko=true
        `);
    }

    @action.bound
    async openInventoryRequestWindowThroughActionsMenu() {
        this.emailType = (await this.inventoryRequestService.checkIsNikoInventoryRequestEligible(this.facilityOrder.id)).data;
        this.hideInventoryEmailButton = (await this.inventoryRequestService.checkSharedNikoInventoryEmailConditions(this.id)).data;
        this.hasValidEmailType = this.emailType != "None";
        if (this.emailType == 'None' || this.hideInventoryEmailButton) {
            this.rootStore.notificationStore.error("Inventory is not necessary because we only supply covered patients in this facility.");
        }
        else {
            window.open(`${this.rootStore.routerStore
                .findRoute('master.app.main.niko-facility-order.niko-inventory-request.new-flow-edit-email')
                .pattern.replace(":facilityOrderId", this.id)
                .replace(":inventoryRequestType", this.emailType)}?isNiko=true
            `);
        }
    }

    @action.bound
    downloadInventoryReport() {
        const facilityInventoryCountDetailService = new FacilityInventoryCountDetailService(this.rootStore.application.baasic.apiClient);
        const downloadUrl = `${facilityInventoryCountDetailService.getDownloadNikoInventoryReportUrl({ facilityOrderId: this.facilityOrder.id })}&contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(downloadUrl, "_blank");
    }

    @action.bound
    async openNikoFacilityOrderUSIntakeFindAndReplaceModal() {
        let errorMessage = null;
        // if (this.facilityOrder.pickTicketHeaderId) {
        //     const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
        //     const pickTicketHeader = (await pickTicketHeaderService.get(this.facilityOrder.pickTicketHeaderId, { embed: "pickTicketHeaderStatus", fields: "pickTicketHeaderStatus" })).data;
        //     if (pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv != "new") {
        //         errorMessage = pickTicketHeader.pickTicketHeaderStatus.abrv == "in-progress" ? "This action is not allowed because purchasing is in progress." : "This action is not allowed because purchasing is complete.";
        //     }
        // }
        if (errorMessage) {
            this.rootStore.notificationStore.error(errorMessage);
            return;
        }
        this.nikoFacilityOrderUSIntakeFindAndReplaceModal.open({
            facilityOrderId: this.facilityOrder.id,
            fetchData: async () => { this.queryUtility.fetch(); }
        });
    }

    @action.bound
    async signalRAction(message) {
        if (message.table == "FO") {
            if (message.column == "SendOrder") {
                this.facilityOrder.sendOrder = true;
            }
            else {
                this.disabled = true;
                await this.queryUtility.fetch();
                this.disabled = false;
            }
        }
        else if (message.table == "PT" || message.table == "PTI" || message.table == "NPD") {
            if (message.table == "NPD") {
                await this.fetchPatientTemplateByPatient(message.id);
            }
            else if (message.patientId) {
                await this.fetchPatientTemplateByPatient(message.patientId);
            }
            else if (message.table == "PTI" && message.customId) {
                await this.fetchPatientTemplateByPatient(message.customId);
            }
            else {
                this.disabled = true;
                await this.queryUtility.fetch();
                this.disabled = false;
            }
        }
        else if (message.table == "P") {
            await this.fetchPatientTemplateByPatient(message.patientId);
        }
        else if (message.table == "NFS" || message.table == "FOS") {
            await this.getFacilityOrderStatus();
            await this.checkIsReviewed();
        }
        else if (message.table == "SE") {
            if (message.column == "EmailType" && message.id == this.facilityOrder.id) {
                if (message.text == "InventoryRequest") {
                    this.isInventoryRequestSent = true;
                    this.getFacilityOrderStatus();
                    this.checkIsReviewed();
                }
            }
        }
    }

    @action.bound
    showPreviousFlag(nikoPatientDetail) {
        return nikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail && (nikoPatientDetail.status != nikoPatientDetail.initialNikoPatientDetail.Status);
    }

    @action.bound
    async reviewDischargePatientTemplates() {
        //         this.disabledPatient = true;
        //         await this.saveTemplates(facilityOrderTemplateId, true);
        //         this.disabledPatient = false;
    }

    @action.bound
    async openReasonForChangeModal(nikoPatientDetail) {
        this.nikoFacilityOrderReasonForChangeModal.open({
            nikoPatientDetail: nikoPatientDetail,
            getNikoPatient: () => this.fetchPatientTemplateByPatient(nikoPatientDetail.id),
            sendOrder: this.facilityOrder && this.facilityOrder.sendOrder,
            showTemplateChangeWarning: (nikoPatientDetail, eligibilityStatusChange, nonEligibilityStatusChange, isParUpdated) => this.showTemplateChangeWarning(nikoPatientDetail, eligibilityStatusChange, nonEligibilityStatusChange, isParUpdated)
            // setNewFlowStatus: async (changeFacilityOrderTemplateStatus) => await this.setNewFlowStatus(newFlowStatusAbrv, null, null, isStatus ? "insurance" : null, true, false, true, changeFacilityOrderTemplateStatus),
            // refreshInsuranceData: async () => await this.fetchPatient(),
            // fetchPatientTemplates: async () => await this.pageViewStore.fetchFacilityOrderTemplatesByPatient(this.facilityOrderPatient.patientId, false, true),
            // changeFacilityOrderPatientInsuranceStatus: () => this.changeFacilityOrderPatientInsuranceStatus(),
            // showTemplateChangeWarning: (facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated) => this.showTemplateChangeWarning(facilityOrderTemplate, checkEligibilityStatusChange, isEligibilityCheck, checkNonEligibilityStatusChange, isParUpdated)
        });
    }

    @action.bound
    async openNikoPatientEligibilityStatusNoteModal(nikoPatientDetail) {
        this.nikoPatientEligibilityStatusNoteModal.open({
            nikoPatientDetail: nikoPatientDetail,
        });
    }

    @action.bound
    showTemplateChangeWarning(
        nikoPatientDetail,
        eligibilityStatusChange,
        nonEligibilityStatusChange,
        isParUpdated,
        template
    ) {
        if (!(nikoPatientDetail && nikoPatientDetail.status == "Active"))
            return;

        if (isParUpdated) {
            return this.templateChangeConfirmModal.open({ message: "PAR flag was updated on a clinically reviewed template. Please ensure that the change you made is accounted for." });
        }
        else if (nonEligibilityStatusChange && this.clinicalReviewStatus && this.clinicalReviewStatus.completedOn) {
            return this.templateChangeConfirmModal.open({ message: "Clinical review has been completed. Please ensure that the change you made is accounted for." });
        }

        if (!(nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name == "Eligible"))
            return;

        if (template && template.isClinicalReviewed && !template.isDiscontinued) {
            return this.templateChangeConfirmModal.open({ message: "This template has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for." });
        }
        else if (eligibilityStatusChange && nikoPatientDetail && nikoPatientDetail.patientTemplates.find(x => x.isClinicalReviewed && !x.isDiscontinued)) {
            return this.templateChangeConfirmModal.open({ message: "At least one of this patient's templates has already been reviewed by Clinical Review. Please ensure that the change you made is accounted for." });
        }
    }

    @action.bound
    async reviewNikoPatient(nikoPatientDetail) {
        nikoPatientDetail.disabled = true;
        nikoPatientDetail.isInsuranceReviewed = !nikoPatientDetail.isInsuranceReviewed;
        await this.nikoPatientDetailService.update(nikoPatientDetail);
        await this.fetchNikoPatientDetailInsuranceStatusById(nikoPatientDetail);
        nikoPatientDetail.disabled = false;
    }

    @action.bound
    async openPatientTemplateInvoiceNoteModal(patientTemplate) {
        this.nikoTemplateInvoiceNoteModal.open({
            patientTemplate: patientTemplate,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate)
        });
    }

    @action.bound
    async openPatientTemplateMissingProductNoteModal(patientTemplate) {
        this.nikoTemplateMissingProductNoteModal.open({
            patientTemplate: patientTemplate,
            showTemplateChangeWarning: () => this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate)
        });
    }

    @action.bound
    async openPatientTemplateNoteModal(patientTemplate) {
        this.patientTemplateNoteModal.open({
            patientTemplate: patientTemplate
        });
    }

    @action.bound
    async openPatientTemplateDiscontinuedModal(patientTemplate) {
        const nikoPatientDetail = this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId);
        const requiresValidation = patientTemplate.isDiscontinued && nikoPatientDetail.status === 'Active';

        this.patientTemplateDiscontinuedModal.open({
            icon: "cross-circle",
            title: `${patientTemplate.isDiscontinued ? "Unmark" : "Mark"} As Discontinued`,
            additionalMessage: requiresValidation
                ? "Template will be reviewed upon activation. Please confirm that you've applied all necessary updates to the patient's insurance and templates."
                : undefined,
            validate: requiresValidation
                ? () => {
                    if (nikoPatientDetail.eligibilityStatus == null) {
                        this.rootStore.notificationStore.error('Eligibility status must be selected prior to activation.');
                        return false;
                    }
                    if (nikoPatientDetail.eligibilityStatus.name === 'Eligible' && nikoPatientDetail.primaryActive.insuranceId.current == null) {
                        this.rootStore.notificationStore.error('Primary Insurance must be added prior to activation.');
                        return false;
                    }
                    return true;
                }
                : undefined,
            action: () => this.markDiscontinued(patientTemplate),
        });
    }

    @action.bound
    async markDiscontinued(patientTemplate) {
        // ISG-871: the backend runs drainage bag / leg bag validations when activating (un-discontinuing) an Active
        // patient's template and returns the resulting warnings.
        const response = await this.patientTemplateService.updateDiscontinuedStatus({ id: patientTemplate.id, isDiscontinued: !patientTemplate.isDiscontinued, pageName: this.pageName });
        await this.fetchPatientTemplateByPatient(patientTemplate.nikoPatientDetailId);

        const validationMessages = response && response.data && response.data.messages;
        if (validationMessages && validationMessages.length) {
            validationMessages.forEach((message) => this.rootStore.notificationStore.warning(message));
        }
    }

    @action.bound
    async openPatientTemplateDoNotSupplyModal(patientTemplate) {
        this.patientTemplateDoNotSupplyModal.open({
            icon: "over-circle",
            title: `${patientTemplate.isUserDns ? "Unmark" : "Mark"} As Do Not Supply`,
            description: patientTemplate.isUserDns ? "Are you sure you want to unmark this order as Do Not Supply?" : undefined,
            action: () => this.markDoNotSupply(patientTemplate)
        });
    }

    @action.bound
    async markDoNotSupply(patientTemplate) {
        patientTemplate.isUserDns = !patientTemplate.isUserDns;
        await this.patientTemplateService.update(patientTemplate);
        this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate);
        // await this.getTemplates()
    }

    @action.bound
    async openClinicalInformationModal(nikoPatientDetail, patientTemplate) {
        this.nikoFacilityOrderUSIntakeClinicalInformationModal.open({
            patientTemplate: patientTemplate,
            nikoPatientDetail: nikoPatientDetail,
            facilityOrder: this.facilityOrder,
            lookups: this.lookups,
            disabled: this.disabledBySendOrder || this.disabledByStatus || this.disabled,
            getNikoPatient: () => this.fetchPatientTemplateByPatient(nikoPatientDetail.id),
            // setDifferentQty: () => this.setDifferentQty(facilityOrderTemplate, "IsDifferentQty,IsDoNotSupply"),
            // setIsQtyChange: () => { this.isQtyChange = true; this.isQtyChange = false; },
        });
    }

    @action.bound
    async openPatientTemplateDeleteModal(nikoPatientDetail, patientTemplate) {
        let params = { facilityOrderId: this.id, nikoPatientDetailId: patientTemplate.nikoPatientDetailId, pageSize: 3, fields: 'Id,TemplateId' };
        var response = (await this.patientTemplateService.find(params)).data.item;
        this.patientTemplateDeleteModal.open({
            item: patientTemplate,
            deleteTemplate: () => this.deleteTemplate(patientTemplate),
            numberOfTemplates: response.every(x => x.id == patientTemplate.id || x.templateId == patientTemplate.id) ? 1 : 2,
            isNewPatient: nikoPatientDetail.isNew
        });
    }

    @action.bound
    async deleteTemplate(patientTemplate) {
        patientTemplate.disabled = true;
        try {
            await this.patientTemplateService.deleteNewTemplate(patientTemplate.id);
            await this.fetchPatientTemplateByPatient(patientTemplate.nikoPatientDetailId);
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occurred while trying to delete a template.");
        }
        finally {
            patientTemplate.disabled = false;
        }
    }

    @action.bound
    async updatePatientTemplateNote(patientTemplate) {
        patientTemplate.note = patientTemplate.tempNote;
        await this.patientTemplateService.update(patientTemplate);
    }

    @action.bound
    async unreviewTemplate() {
        //         this.disabledPatient = true;
        //         await this.reviewActiveTemplates("in-progress", facilityOrderTemplateId, false);
        //         this.disabledPatient = false;
    }

    @action.bound
    isDisabledTemplateReview(nikoPatientDetail) {
        return (nikoPatientDetail.patientTemplates.some(x => !x.isNew) && nikoPatientDetail.insuranceStatusId === this.inProgressStatusId) ||
            ((nikoPatientDetail.isNew || nikoPatientDetail.insuranceStatusId === this.changeStatusId) && !nikoPatientDetail.isInsuranceReviewed);
    }

    @action.bound
    async addEmptyItem(patientTemplate) {
        if (patientTemplate.patientTemplateItems.some(i => !i.productId)) {
            return;
        }

        await this.setProductStore(patientTemplate);
        patientTemplate.patientTemplateItems.push({
            id: uuid(),
            quantity: 0,
            salesOrderQuantity: null,
            note: undefined,
            itemCals: undefined,
            itemMls: undefined,
            mlph: undefined,
            frequency: undefined,
            procedureCode: null,
            patientTemplatId: patientTemplate.id,
            productId: null,
            product: null,
            actionId: this.insertImportActionId,
            toggle: !this.templateChangeConfirmModal.isOpen
        });
    }

    @action.bound
    async setProductStore(patientTemplate) {
        const nikoPatientDetail = this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId);
        const isMasterPatient = nikoPatientDetail && this.isMasterPatient(nikoPatientDetail);

        patientTemplate.productStore = new BaasicDropdownStore({
            filterable: true,
            textField: "itemId",
        }, {
            fetchFunc: async (term) => {
                if ((term && term.trim()) === '')
                    term = undefined;

                let params = {
                    searchQuery: term,
                    rpp: 50,
                    subCategoryId: patientTemplate.subCategoryId,
                    isActive: true,
                    embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_"
                }

                if (this.ostomySubCategoryId == patientTemplate.subCategoryId) {
                    params = { ...params, sort: "isPreferred|desc" };
                }

                const response = await this.itemSubcategoryService.find(params);
                let filteredProducts = isMasterPatient ? response.data.item : response.data.item.filter(x => !x.product.itemId.toLowerCase().includes("-cs"));
                return _.map(filteredProducts, item => {
                    return {
                        ...item.product
                    };
                });
            }
        });
    }

    @action.bound
    async saveItemOnProductSelect(patientTemplate, patientTemplateItem, product) {
        patientTemplate.disabled = true;
        if (!patientTemplate.isNew && patientTemplate.subCategory.abrv === 'Trach-Tube' && patientTemplate.patientTemplateItems.some(x => x.productId && x.actionId !== this.deleteImportActionId)) {
            this.rootStore.modalStore.showConfirm('FACILITY_ORDER_TEMPLATE.EDIT.CONFIRM_DELTE_TRACH_TUBE_ITEMS', async () => {
                await this.saveItem(patientTemplate, patientTemplateItem, product);
            });
        }
        else {
            await this.saveItem(patientTemplate, patientTemplateItem, product);
        }
    }

    @action.bound
    async saveItem(patientTemplate, patientTemplateItem, product) {

        try {
            const nikoPatientDetail = this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId);
            const isMasterPatient = nikoPatientDetail && this.isMasterPatient(nikoPatientDetail);

            const isEnteral = patientTemplate.itemCategoryId === this.enteralItemCategoryId;
            const isFormula = product.itemTypeId || (product.procedureCode_ && product.procedureCode_.abrv === "B4155");

            if (isMasterPatient) {
                const response = await this.patientTemplateItemService.create({
                    product: product,
                    productId: product.id,
                    patientTemplateId: patientTemplate.id,
                    quantity: 0,
                    salesOrderQuantity: 0,
                    note: null,
                    procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
                });
                const created = { ...response.data, product: product };
                const pos = patientTemplate.patientTemplateItems.findIndex((i) => patientTemplateItem.id === i.id);
                if (pos > -1) {
                    patientTemplate.patientTemplateItems.splice(pos, 1, created);
                    await this.fetchPatientTemplateByPatient(patientTemplate.nikoPatientDetailId);
                }
                else {
                    patientTemplate.patientTemplateItems.push(created);
                }
                this.showTemplateChangeWarning(nikoPatientDetail, false, false, false, patientTemplate);
                return;
            }

            let tempItem = {
                product: product,
                productId: product.id,
                procedureCode: product.procedureCode_ && product.procedureCode_.abrv,
            };

            if (isEnteral && isFormula) {
                _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
            }

            const items = (await this.patientTemplateItemService.createAdditionalItems(
                {
                    patientTemplateItem: tempItem,
                    patientTemplateItems: patientTemplate.patientTemplateItems.filter((i) => i.productId).map((i) => { return { id: i.id, product: i.product, productId: i.productId, procedureCode: i.procedureCode, actionId: i.ationId }; }),
                    facilityId: this.facilityOrder.facilityId,
                    subCategoryId: patientTemplate.subCategoryId,
                    clinicalStatusId: patientTemplate.clinicalStatusId,
                    patientTemplateId: patientTemplate.id,
                    pageName: this.pageName,
                    tabName: this.selectedStatusAbrv,
                }
            )).data;

            for (const item of items) {
                let updatepatientTemplateItem = patientTemplate.patientTemplateItems.find(x => x.id === item.id);
                if (updatepatientTemplateItem) {
                    updatepatientTemplateItem.procedureCode = item.procedureCode;
                    continue;
                }

                const response = await this.patientTemplateItemService.create({
                    id: item.id,
                    product: item.product,
                    productId: item.product.id,
                    patientTemplateId: patientTemplate.id,
                    quantity: item.quantity || 0,
                    salesOrderQuantity: item.salesOrderQuantity || 0,
                    note: item.note || null,
                    procedureCode: item.procedureCode,
                });
                const created = { ...response.data, product: item.product };
                const pos = patientTemplate.patientTemplateItems.findIndex((i) => patientTemplateItem.id === i.id);
                if (pos > -1) {
                    patientTemplate.patientTemplateItems.splice(pos, 1, created);
                    await this.fetchPatientTemplateByPatient(patientTemplate.nikoPatientDetailId);
                }
                else {
                    patientTemplate.patientTemplateItems.push(created);
                }
            }
            this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate);

            if (isEnteral && isFormula) {
                const formulaItem = patientTemplate.patientTemplateItems.find(i => i.product && i.product.id === tempItem.productId);
                if (formulaItem) {
                    this.openNikoPatientTemplateItemCalculationModal(formulaItem, patientTemplate, false);
                }
            }

        }
        catch (err) {
            this.rootStore.notificationStore.error(err.data ? err.data : "Error while adding additional items");
        }
        finally {
            patientTemplate.disabled = false;
        }
    }

    @action.bound
    openNikoPatientTemplateItemCalculationModal(patientTemplateItem, patientTemplate, showWarning = true) {
        this.nikoPatientTemplateItemCalculationModal.open({
            patientTemplateItem: patientTemplateItem,
            facilityId: this.facilityOrder.facilityId,
            patientTemplateItemService: this.patientTemplateItemService,
            updateItem: async (patientTemplateItem) => {
                await this.updateItem(patientTemplateItem);
                await this.fetchPatientTemplateItemsById(patientTemplate.nikoPatientDetailId, patientTemplate.id);
                await this.fetchPatientTemplateIntakeStatusById(patientTemplate);
            },
            showTemplateChangeWarning: showWarning ? () => this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate) : undefined,
        });
    }

    @action.bound
    editItem(item, propertyName, value) {
        item[propertyName] = value;
        if (propertyName === "quantity") {
            item["salesOrderQuantity"] = value;
        }
    }

    @action.bound
    showItemQuantities(patientTemplate, show) {
        this.templateExpanded = { id: patientTemplate.id, expanded: show };
    }

    @action.bound
    async updateItem(patientTemplateItem, patientTemplate) {
        if (patientTemplate) {
            patientTemplate.disabled = true;
        }

        if (Number.isNaN(patientTemplateItem.quantity) || patientTemplateItem.quantity === '' || patientTemplateItem.quantity === null || patientTemplateItem.quantity === undefined) {
            patientTemplateItem.quantity = 0;
        }
        if (Number.isNaN(patientTemplateItem.salesOrderQuantity) || patientTemplateItem.salesOrderQuantity === '' || patientTemplateItem.salesOrderQuantity === null || patientTemplateItem.salesOrderQuantity === undefined) {
            patientTemplateItem.salesOrderQuantity = 0;
        }

        if (patientTemplateItem.quantity == patientTemplateItem.savedQuantity &&
            patientTemplateItem.salesOrderQuantity == patientTemplateItem.savedSalesOrderQuantity &&
            patientTemplateItem.note == patientTemplateItem.savedNote) {
            if (patientTemplate) {
                patientTemplate.disabled = false;
            }
            return;
        }

        await this.patientTemplateItemService.update(patientTemplateItem.id, {
            productId: patientTemplateItem.productId,
            patientTemplateId: patientTemplateItem.patientTemplateId,
            quantity: patientTemplateItem.quantity,
            salesOrderQuantity: patientTemplateItem.salesOrderQuantity,
            note: patientTemplateItem.note,
            procedureCode: patientTemplateItem.procedureCode,
            mlph: patientTemplateItem.mlph,
            itemMls: patientTemplateItem.itemMls,
            itemCals: patientTemplateItem.itemCals,
            frequency: patientTemplateItem.frequency,
            actionId: patientTemplateItem.actionId
        });

        patientTemplateItem.savedQuantity = patientTemplateItem.quantity;
        patientTemplateItem.savedSalesOrderQuantity = patientTemplateItem.salesOrderQuantity;
        patientTemplateItem.savedNote = patientTemplateItem.note;
        if (patientTemplate) {
            patientTemplate.isDifferentQty = patientTemplate.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
            await this.fetchPatientTemplateIntakeStatusById(patientTemplate);
            this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate);
            patientTemplate.disabled = false;
        }
    }

    @action.bound
    async deletePatientTemplateItem(patientTemplateItem, patientTemplate, nikoPatientDetail) {
        patientTemplate.disabled = true;
        if (nikoPatientDetail.isNew && nikoPatientDetail.patientTemplates.every(x => x.id == patientTemplate.id || x.templateId == patientTemplate.id) && patientTemplate.patientTemplateItems.length == 1) {
            let params = { facilityOrderId: this.id, nikoPatientDetailId: patientTemplate.nikoPatientDetailId, pageSize: 3, fields: 'Id,TemplateId' };
            var response = (await this.patientTemplateService.find(params)).data.item;

            if (response.every(x => x.id == patientTemplate.id || x.templateId == patientTemplate.id)) {
                return this.nikoPatientTemplateItemNewFlowDeleteQuestionModal.open({
                    deleteItem: () => this.deleteItem(patientTemplate, patientTemplateItem, false),
                    deletePatient: () => this.deleteItem(patientTemplate, patientTemplateItem, true)
                });
            }
        }

        if (patientTemplateItem.actionId == this.insertImportActionId) {
            await this.deleteItem(patientTemplate, patientTemplateItem, patientTemplate.isNew);
        }
        else {
            await this.setAction(patientTemplateItem, this.deleteImportActionId, patientTemplate);
        }
        patientTemplate.disabled = false;
    }

    @action.bound
    async deleteItem(patientTemplate, patientTemplateItem, deleteTemplate) {
        patientTemplate.disabled = true;
        if (deleteTemplate && patientTemplate.patientTemplateItems.length === 1) {
            return await this.deleteTemplate(patientTemplate);
        }

        if (patientTemplateItem.productId) {
            const procedureCode = patientTemplateItem.product && patientTemplateItem.product.procedureCode_ && patientTemplateItem.product.procedureCode_.abrv;
            const hasSyringeItem = patientTemplate.patientTemplateItems && patientTemplate.patientTemplateItems.some(x => x.product && x.product.defaultItemTypeId == this.syringeDefaultItemTypeId);
            await this.patientTemplateItemService.delete(patientTemplateItem.id, { setProcedureCode: (procedureCode == 'B4035' || procedureCode == 'B4036') && hasSyringeItem });
            runInAction(() => {
                patientTemplate.patientTemplateItems = patientTemplate.patientTemplateItems.filter((i) => i !== patientTemplateItem); //((i) => i.id !== patientTemplateItem.id)
            });

            if ((procedureCode == 'B4035' || procedureCode == 'B4036') && hasSyringeItem) {
                await this.fetchPatientTemplateItemsById(patientTemplate.nikoPatientDetailId, patientTemplate.id);
            }
            patientTemplate.isDifferentQty = patientTemplate.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
            await this.fetchPatientTemplateIntakeStatusById(patientTemplate);
            this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate);
        }
        else {
            runInAction(() => {
                patientTemplate.patientTemplateItems = patientTemplate.patientTemplateItems.filter((i) => i !== patientTemplateItem); //((i) => i.id !== patientTemplateItem.id)
            });
            patientTemplate.isDifferentQty = patientTemplate.patientTemplateItems.some(x => x.quantity != x.salesOrderQuantity);
        }

        patientTemplate.disabled = false;
    }

    @action.bound
    async swapPatientTemplateItem(patientTemplateItem, patientTemplate, nikoPatientDetail) {
        patientTemplate.disabled = true;
        try {
            if (patientTemplateItem.actionId === this.deleteImportActionId) {
                await this.setAction(patientTemplateItem, this.updateImportActionId, patientTemplate)
            }
            else {
                await this.deletePatientTemplateItem(patientTemplateItem, patientTemplate, nikoPatientDetail)
            }
            this.addEmptyItem(patientTemplate);
        }
        catch (err) {
            this.rootStore.notificationStore.error("FACILITY_ORDER_TEMPLATE_ITEM.EDIT.DELETE_ERROR");
        }
        patientTemplate.disabled = false;
    }

    @action.bound
    async setAction(patientTemplateItem, actionId, patientTemplate) {
        patientTemplateItem.actionId = actionId;
        const procedureCode = patientTemplateItem.product && patientTemplateItem.product.procedureCode_ && patientTemplateItem.product.procedureCode_.abrv;
        const hasSyringeItem = patientTemplate.patientTemplateItems && patientTemplate.patientTemplateItems.some(x => x.product && x.product.defaultItemTypeId == this.syringeDefaultItemTypeId);
        await this.patientTemplateItemService.update(patientTemplateItem.id, { ...patientTemplateItem, setProcedureCode: (procedureCode == 'B4035' || procedureCode == 'B4036') && hasSyringeItem });
        if ((procedureCode == 'B4035' || procedureCode == 'B4036') && hasSyringeItem) {
            await this.fetchPatientTemplateItemsById(patientTemplate.nikoPatientDetailId, patientTemplate.id);
        }
        await this.fetchPatientTemplateIntakeStatusById(patientTemplate);
        this.showTemplateChangeWarning(this.nikoPatientDetails.find(x => x.id == patientTemplate.nikoPatientDetailId), false, false, false, patientTemplate);
    }

    @action.bound
    async unreviewDischargePatientTemplates() {
        //         this.disabledPatient = true;
        //         this.saveTemplates(facilityOrderTemplateId, false);
        //         this.disabledPatient = false;
    }

    @action.bound
    handleDropDownItemsOnClick() {
    }

    @action.bound
    orderHistory() {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.niko-facility-order.history").pattern.replace(":id", this.facilityOrder.id));
    }

    @action.bound
    getChangedFields(nikoPatientDetail) {
        var fields = [];
        var npd = nikoPatientDetail;
        if (!npd.isNew) {
            if (npd.primaryActive.insuranceId.current != npd.primaryActive.insuranceId.initial)
                fields.push({ fieldName: "PrimaryActiveInsuranceId", value: npd.primaryActive.insuranceId.current || null, initialValue: npd.primaryActive.insuranceId.initial || null });
            if (npd.primaryActive.insuranceId.current == npd.primaryActive.insuranceId.initial && npd.primaryActive.policyNo.current != npd.primaryActive.policyNo.initial)
                fields.push({ fieldName: "PrimaryActivePolicyNo", value: npd.primaryActive.policyNo.current || null, initialValue: npd.primaryActive.policyNo.initial || null });
            if (npd.primaryInactive.insuranceId.current && npd.primaryInactive.insuranceId.current != npd.primaryInactive.insuranceId.initial)
                fields.push({ fieldName: "PrimaryInactiveInsuranceId", value: npd.primaryInactive.insuranceId.current || null, initialValue: npd.primaryInactive.insuranceId.initial || null });
            if (npd.primaryInactive.insuranceId.current && npd.primaryInactive.insuranceId.current == npd.primaryInactive.insuranceId.initial && npd.primaryInactive.policyNo.current != npd.primaryInactive.policyNo.initial)
                fields.push({ fieldName: "PrimaryInactivePolicyNo", value: npd.primaryInactive.policyNo.current || null, initialValue: npd.primaryInactive.policyNo.initial || null });
            if (npd.secondaryActive.insuranceId.current != npd.secondaryActive.insuranceId.initial)
                fields.push({ fieldName: "SecondaryActiveInsuranceId", value: npd.secondaryActive.insuranceId.current || null, initialValue: npd.secondaryActive.insuranceId.initial || null });
            if (npd.secondaryActive.insuranceId.current == npd.secondaryActive.insuranceId.initial && npd.secondaryActive.policyNo.current != npd.secondaryActive.policyNo.initial)
                fields.push({ fieldName: "SecondaryActivePolicyNo", value: npd.secondaryActive.policyNo.current || null, initialValue: npd.secondaryActive.policyNo.initial || null });
            if (npd.secondaryInactive.insuranceId.current && npd.secondaryInactive.insuranceId.current != npd.secondaryInactive.insuranceId.initial)
                fields.push({ fieldName: "SecondaryInactiveInsuranceId", value: npd.secondaryInactive.insuranceId.current || null, initialValue: npd.secondaryInactive.insuranceId.initial || null });
            if (npd.secondaryInactive.insuranceId.current && npd.secondaryInactive.insuranceId.current == npd.secondaryInactive.insuranceId.initial && npd.secondaryInactive.policyNo.current != npd.secondaryInactive.policyNo.initial)
                fields.push({ fieldName: "SecondaryInactivePolicyNo", value: npd.secondaryInactive.policyNo.current || null, initialValue: npd.secondaryInactive.policyNo.initial || null });
            if (npd.eligibilityStatusId != (npd.initialNikoPatientDetail ? npd.initialNikoPatientDetail.EligibilityStatusId : null))
                fields.push({ fieldName: "EligibilityStatusId", value: npd.eligibilityStatusId || null, initialValue: npd.initialNikoPatientDetail ? npd.initialNikoPatientDetail.EligibilityStatusId || null : null });
            npd.patientTemplates.forEach(function (pt) {
                if (!pt.isNew && (pt.isPriorAuthNeeded ? true : false) != (pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? true : false))
                    fields.push({ fieldName: "PAR_" + pt.id, value: pt.isPriorAuthNeeded ? "TRUE" : "FALSE", initialValue: pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? "TRUE" : "FALSE" });
            });
        }
        if (npd.note)
            fields.push({ fieldName: "Note", value: npd.note, initialValue: null });
        return fields;
    }

    @action.bound
    setShowInsuranceChangeHistory(value) {
        this.showInsuranceChangeHistory = value;
    }

    @action.bound
    async fetchInsuranceChangeHistory(nikoPatientDetail) {
        var fields = this.getChangedFields(nikoPatientDetail);
        if (fields.length === 0) return;
        try {
            const response = await this.historyService.getInsuranceChangeHistory(nikoPatientDetail.id, fields);
            const data = response.data || response;
            var historyMap = {};
            if (Array.isArray(data)) {
                data.forEach(function (entry) {
                    historyMap[entry.fieldName] = entry;
                });
            }
            runInAction(() => {
                this.insuranceChangeHistoryMap = Object.assign({}, this.insuranceChangeHistoryMap, { [nikoPatientDetail.id]: historyMap });
            });
        } catch (err) {
            runInAction(() => {
                this.insuranceChangeHistoryMap = Object.assign({}, this.insuranceChangeHistoryMap, { [nikoPatientDetail.id]: {} });
            });
        }
    }

    @action.bound
    async getFieldHistory(item, fieldName, value) {
        if (item.history) {
            let history;
            if (fieldName === 'ImportAction') {
                history = (await this.historyService.getItemActionHistory(item.id)).data;
            } else {
                history = (await this.historyService.getRecordHistory({ recordId: item.id, fieldName: fieldName, value: value })).data;
            }
            item.history.userName = history.userName;
            item.history.eventDate = history.eventDate;
            item.history.fieldName = fieldName;
            if (history.action) item.history.action = history.action;
        }
    }
}

export default NikoFacilityOrderUSIntakePreviewViewStore;
